import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const TruckIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 33 32"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M31.5 18V8a2 2 0 0 0-2-2h-16a2 2 0 0 0-2 2v8M11.5 16V8h-4a6 6 0 0 0-6 6v8a2 2 0 0 0 2 2h1"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M1.5 16h4a2 2 0 0 0 2-2V8M10.5 26a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM26.5 26a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM16.5 24h4"
            />
        </svg>
    </IconWrapper>
)
